// extracted by mini-css-extract-plugin
module.exports = {"list":"BlogList_list__CR95y","item":"BlogList_item__mllyo","itemSingle":"BlogList_itemSingle__n9OZp","more":"BlogList_more__Egmp5"};